import { ViewportScroller } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  ChildrenOutletContexts,
  Router,
  RouterModule,
  Scroll,
} from '@angular/router';
import { DateFnsModule } from 'ngx-date-fns';
import { filter } from 'rxjs';

import { SharedAuthFacade } from '@lockton-apps/shared/data-access/auth';
import { FeedbackService } from '@lockton-apps/shared/ui/lui';
import { AuthUserIdleService } from '@lockton-apps/shared/util/auth-user-idle';
import { FreshdeskService } from '@lockton-apps/shared/util/freshdesk';
import {
  DevModeManagerDirective,
  ExperimentalManagerDirective,
  IfDevDirective,
  isExperimental,
} from '@lockton-apps/shared/util/helpers';
import { LocalizationService } from '@lockton-apps/shared/util/localization';
import { OneTrustLoaderService } from '@lockton-apps/shared/util/onetrust';

import { LayoutComponent } from './layout/layout.component';
import { DevPanelComponent } from '@lockton-apps/shared/ui/dev-panel';

@Component({
    imports: [
        RouterModule,
        DateFnsModule,
        LayoutComponent,
        DevPanelComponent,
        IfDevDirective,
    ],
    selector: 'latam-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    hostDirectives: [ExperimentalManagerDirective, DevModeManagerDirective]
})
export class AppComponent implements OnInit, AfterViewInit {
  @ViewChild('timeoutTemplate') timeoutTemplate!: TemplateRef<any>;

  constructor(
    private contexts: ChildrenOutletContexts,
    private authFacade: SharedAuthFacade,
    private localizationService: LocalizationService,
    private oneTrust: OneTrustLoaderService,
    private feedbackService: FeedbackService,
    private authUserIdleService: AuthUserIdleService,
    router: Router,
    viewportScroller: ViewportScroller,
    freshdesk: FreshdeskService
  ) {
    router.events
      .pipe(filter((event) => event instanceof Scroll))
      .subscribe((e) => {
        const event = e as Scroll;
        if (event.position) {
          // backward navigation
          viewportScroller.scrollToPosition(event.position);
        } else if (event.anchor) {
          // anchor navigation
          viewportScroller.scrollToAnchor(event.anchor);
        } else {
          // forward navigation
          // check url if page exists do not scroll
          if (
            !(
              event.routerEvent.url.includes('page') ||
              event.routerEvent.url.includes('ns=t') ||
              event.routerEvent.url.includes('limit')
            )
          ) {
            viewportScroller.scrollToPosition([0, 0]);
          }
        }
      });

    freshdesk.init();
  }

  ngOnInit(): void {
    this.oneTrust.load();

    this.authFacade.init();

    this.localizationService.initialiseLocale('pt');

    if (isExperimental()) {
      this.feedbackService.subtleMessage(
        $localize`Experimental mode is active`,
        { type: 'info' }
      );
    }
  }

  ngAfterViewInit(): void {
    this.authUserIdleService.init(this.timeoutTemplate);
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'animation'
    ];
  }
}
